var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAuthen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google_authen",
    transform: "translate(299 -8211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify_acc",
    transform: "translate(-219 83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 64,
    height: 64,
    transform: "translate(-80 8128)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e5624d39b35c645fcb2dc242597966b6",
    transform: "translate(-77.942 8130.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150",
    "data-name": "Rectangle 2150",
    width: 60,
    height: 60,
    rx: 5.917,
    transform: "translate(-0.058 -0.058)",
    fill: "#017f99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18569",
    "data-name": "Group 18569",
    transform: "translate(0 1.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24640",
    "data-name": "Path 24640",
    d: "M20.133,3.5A27.291,27.291,0,0,1,6.51,10.973V24.664c0,7.373,5.448,10.138,13.62,14.749h.023c8.172-4.611,13.62-7.376,13.62-14.749v-13.7A27.291,27.291,0,0,1,20.133,3.5Z",
    transform: "translate(-287.142 8221.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18568",
    "data-name": "Group 18568",
    transform: "translate(31.65 -122.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24648",
    "data-name": "Path 24648",
    d: "M26.3,18.4a7.9,7.9,0,1,1-7.9-7.9A7.9,7.9,0,0,1,26.3,18.4Z",
    transform: "translate(-317.051 8348.282)",
    fill: "#017f99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ec16009dd77653536180dea93c22a3fa",
    transform: "translate(-273.158 8237.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24636",
    "data-name": "Path 24636",
    d: "M6.874,3.6a2.17,2.17,0,0,1,1.535.6L9.561,3.046A3.86,3.86,0,0,0,6.874,2,4.015,4.015,0,0,0,3.285,4.212L4.627,5.253A2.393,2.393,0,0,1,6.874,3.6Z",
    transform: "translate(-0.636 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24637",
    "data-name": "Path 24637",
    d: "M2.649,7.509a4.021,4.021,0,0,0,0,3.607l1.342-1.041a2.375,2.375,0,0,1,0-1.526Z",
    transform: "translate(0 -3.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24638",
    "data-name": "Path 24638",
    d: "M8.234,15.172A2.423,2.423,0,0,1,4.627,13.9L3.285,14.941a4.015,4.015,0,0,0,3.589,2.213,3.834,3.834,0,0,0,2.658-.973Z",
    transform: "translate(-0.636 -7.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18567",
    "data-name": "Group 18567",
    transform: "translate(6.238 5.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24639",
    "data-name": "Path 24639",
    d: "M16,10.182H12.222v1.553h2.161a1.847,1.847,0,0,1-.8,1.212l0,0,0,0,1.3,1.008h0A3.917,3.917,0,0,0,16.077,11,4.615,4.615,0,0,0,16,10.182Z",
    transform: "translate(-12.222 -10.182)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuthen);
export default __webpack_public_path__ + "static/media/google_authen.c75a296da9e280c42bb3dd87b89a6220.svg";
export { ForwardRef as ReactComponent };